import React, { useState } from 'react';
import './header.sass';
import Logo from '../../../landing-page/vendor/assets/Logo.png';
import { Button, ButtonSize, ButtonType } from '../../../../components/interface/button/button';
import { NavLink } from 'react-router-dom';
import { Config } from '../../../../config/config';
import { LogoutModal } from '../logout-modal/logout-modal';

export const Header = ({withNavigation = false}) => {

    const paths = Config.routePaths;

    const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

    const renderNavigation = () => {
      return <nav className='vv-navigation__right'>
        <NavLink className='vv-navigation__element' to={paths.main.vendor.dashboard.discount.path}>Zniżki</NavLink>
        <NavLink className='vv-navigation__element' to={paths.main.vendor.dashboard.challenges.path}>Wyzwania</NavLink>
        <NavLink className='vv-navigation__element' to={paths.main.vendor.dashboard.team.path}>Personel</NavLink>
        <NavLink className='vv-navigation__element' to={paths.main.vendor.dashboard.payments.path}>Płatności</NavLink>
        <NavLink className='vv-navigation__element' to={paths.main.vendor.dashboard.profile.path}>Profil</NavLink>
        <NavLink className='vv-navigation__element' to={paths.main.vendor.dashboard.settings.path}>Ustawienia</NavLink>
      </nav>;
    };

    return (
        <div className='vv-configuration-vendor-header-container'>
            <div className='vv-configuration-vendor-header'>
                <div className='vv-configuration-vendor-header__left'>
                    <img className='vv-configuration-vendor-header__logo' src={Logo}/>
                    <p>Dla partnerów</p>
                </div>
                <div className='vv-configuration-vendor-header__right'>
                    {withNavigation ? renderNavigation() : null}
                    <Button size={ButtonSize.NO_PADDING} buttonType={ButtonType.TRANSPARENT} text='WYLOGUJ SIĘ' onClick={() => setIsLogoutModalVisible(true)} />
                    <LogoutModal isVisible={isLogoutModalVisible} setIsVisible={setIsLogoutModalVisible}/>
                </div>
            </div>
        </div>
    );
};
